module.exports = __webpack_public_path__ + "img/js.8c83f38f.png";